import { infoCard } from "./infoCard.js";

export const tabSwitch = {
    mainContainer: null,
    tabBtns: [],
    calcTab: null,
    contactTab: null,
    footer: null,

    setElements() {
        this.mainContainer = document.querySelector('#plans-prices .main-content__tabs');
        this.tabBtns = document.querySelectorAll('#plans-prices .tabs__tab-btn');
        this.calcTab = document.querySelector('#plans-prices .tabs__calc');
        this.contactTab = document.querySelector('#plans-prices .tabs__contact');
        this.footer = document.querySelector('#plans-prices .tabs__footer');
    },

    changeTab(selectedPlan) {
        if (!this.mainContainer) this.setElements();
        if (!this.mainContainer) return;

        this.tabBtns.forEach(btn => {
            btn.classList.remove('selected');
            if (btn.dataset.planTitle === selectedPlan) {
                btn.classList.add('selected');
            }
        });

        this.mainContainer.dataset.selectedTab = selectedPlan;

        if (selectedPlan == 'enterprise') {
            this.calcTab.classList.add('hide');
            this.footer.classList.add('hide');
            this.contactTab.classList.remove('hide');
            infoCard.updatePlanPrice('?');
            infoCard.updatePlanPrompt('enterprise');
        } else {
            this.calcTab.classList.remove('hide');
            this.contactTab.classList.add('hide');
            this.footer.classList.remove('hide');
        }
        this.mainContainer.dispatchEvent(new CustomEvent('tab-change', {
            detail: {
                plan: selectedPlan
            }
        }))

        infoCard.updateFeaturesList(selectedPlan);
        infoCard.updatePlanTitle(selectedPlan);
        infoCard.updatePlanPrompt(selectedPlan);
    },

    init() {
        this.setElements();
        if (!this.mainContainer) return;

        this.tabBtns.forEach(btn => btn.addEventListener('click', (e) => {
            this.changeTab(e.currentTarget.dataset.planTitle);
        }));
    }
}
